import { api } from 'cssapi'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'
import { randomBool, randomNumberInRange } from '../../helpers/random'

const yRange = 6

const generatePoly = () => {
  const narrowLeft = randomBool()
  const topLeftY = narrowLeft ? randomNumberInRange(-yRange, yRange) : 0
  const topRightY = narrowLeft ? 0 : randomNumberInRange(-yRange, yRange)
  const bottomLeftY = narrowLeft
    ? 100 + randomNumberInRange(-yRange, yRange)
    : 100
  const bottomRightY = narrowLeft
    ? 100
    : 100 + randomNumberInRange(-yRange, yRange)
  // return `polygon(0 5%, 100% 0, 100% 100%, 0 96%)`

  return `polygon(0 ${topLeftY}%, 100% ${topRightY}%, 100% ${
    bottomRightY
  }%, 0 ${bottomLeftY}%)`
}

const offsets = p => {
  let top = 2
  let right = -2

  if (p.offset === `topRight`) {
    top = -2
    right = 3
  }

  top += randomNumberInRange(-2, 2)
  right += randomNumberInRange(-2, 2)

  return css`
    transform: translate(${right}%, ${top}%);
  `
}

const offsetsHover = p => {
  let top = 1
  let right = -1.5

  if (p.offset === `topRight`) {
    top = -0.75
    right = 2
  }

  return css`
    transform: translate(${right}%, ${top}%);
  `
}

const Layout = styled.div`
  position: relative;
  width: 100%;
  opacity: 0.9;

  ::before {
    content: '';
    z-index: -1;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    transform: scale(1.03, 1.03);

    ${api({
      backgroundColor: `c:backgroundInverted`,
    })};

    @supports (clip-path: ${p => p.poly}) {
      display: block;
      clip-path: ${p => p.poly};
    }
  }
`

const BackgroundLayer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  transition: all 1s ease-in-out;

  ${offsets};

  @supports (clip-path: ${p => p.poly}) {
    display: block;
    clip-path: ${p => p.poly};
  }

  a:hover & {
    ${offsetsHover};
    transition: all 0.5s ease-in-out;
  }
`

const ImageWrapper = styled.div`
  z-index: 1;
  position: relative;

  @supports (clip-path: ${p => p.poly}) {
    display: block;
    clip-path: ${p => p.poly};
  }

  > * {
    display: block;
    width: 100%;
    height: auto;
    z-index: -1;
  }
  @supports (filter: grayscale(1) contrast(1.4)) {
    filter: grayscale(1) contrast(1.2);
  }
`

const PolyImage = ({ imageSizes, poly }) => {
  poly = generatePoly()

  const color = `#666`

  return (
    <Layout poly={poly}>
      <BackgroundLayer poly={poly} color={color} offset="topRight" />
      <BackgroundLayer poly={poly} color={color} offset="bottomLeft" />
      <ImageWrapper poly={poly} color={color}>
        <Img sizes={imageSizes} />
      </ImageWrapper>
    </Layout>
  )
}

PolyImage.propTypes = {
  imageSizes: PropTypes.object.isRequired,
  poly: PropTypes.func,
}

PolyImage.defaultProps = {
  poly: () => generatePoly(),
}

export default PolyImage



// WEBPACK FOOTER //
// ./src/components/shared/PolyImage/PolyImage.jsx